import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import Typography from '@mui/material/Typography'

export default function ListSort({ title, value, fields, onChange, style }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderBottom: theme => `1px solid ${theme.palette.divider}`,
        flexDirection: 'row',
        ...style,
      }}
    >
      {title && (
        <Typography variant="caption" component="p" sx={{ ml: 2 }}>
          {title}
        </Typography>
      )}
      <div style={{ flex: 1 }} />
      {fields.map(x => (
        <div key={x.id}>
          <ButtonBase onClick={() => onChange(x.id)} sx={{ p: 2, display: 'block', width: '100%' }}>
            <Typography
              style={{ display: 'flex', alignItems: 'center' }}
              align="left"
              variant="caption"
            >
              {x.name}
              {value.field === x.id &&
                (value.order === 'asc' ? (
                  <ArrowDownwardIcon sx={{ marginTop: '-1px', ml: 1, fontSize: 16 }} />
                ) : (
                  <ArrowUpwardIcon sx={{ marginTop: '-1px', ml: 1, fontSize: 16 }} />
                ))}
            </Typography>
          </ButtonBase>
        </div>
      ))}
    </Box>
  )
}
